export interface DocPopup {
    heading?: string;
    message: string;
    buttonText: string;
    type: DocPopupTypes;
    showCancelBtn?: boolean;
}

export enum DocPopupTypes {
    error = 'error',
    info = 'info',
    success = 'success'
}